export default __webpack_public_path__ + "static/media/solution_63.617e11ec.svg";